export const COLUMN_MODAL_OPEN = 'COLUMN_MODAL_OPEN';
export const COLUMN_MODAL_CLOSE = 'COLUMN_MODAL_CLOSE';

export const openColumnModal = () => ({type: COLUMN_MODAL_OPEN});

export const closeColumnModal = () => ({type: COLUMN_MODAL_CLOSE});

